export default "__VITE_ASSET__rHwYoKph__"